import React, { 
  useRef,
  useState, 
  useEffect 
} from 'react';
import { graphql, useStaticQuery, Script, } from "gatsby"
import { disableBodyScroll, enableBodyScroll, } from 'body-scroll-lock';
import { useInView } from 'react-intersection-observer';
import { useMediaQuery } from 'react-responsive';
import {
  Menu,
  Segment,
  Sidebar,
  Container,
  Icon,
  Button,
} from 'semantic-ui-react';

import components from "../components/components"
import Footer from "./footer/footer"
import NavItemSocialIcons from "../components/navigation/NavItemSocialIcons"

// Theme
import '../theme/triton-default.scss';
//import '../../themes/triton-default/triton-default.scss';
// Styles
import * as styles from './default-layout.module.scss';

const GATSBY_GOOGLE_ANALYTICS = process.env.GATSBY_GOOGLE_ANALYTICS;
const GATSBY_GOOGLE_TAG = process.env.GATSBY_GOOGLE_TAG;

const TritonDefaultLayout = (props) => {
  //console.debug('TritonDefaultLayout - props', props);
  const refMobileSidebarMenuTarget = useRef(null);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  //const isMobile = useMediaQuery({ query: '(max-width: 767px)' })
  //const isNotMobile = useMediaQuery({ minWidth: 768 });

  //orchard query
  const data = useStaticQuery(graphql`
    query SiteLayoutQuery {
      siteData {
        contentItemId
        contentType
        displayText
        layout {
          contentItems {
            ...Layout
          }
        }
      }
    }
  `)

  const { siteData } = data;
  //console.debug('TritonDefaultLayout - siteData', siteData);
  const { navigation, footer } = siteData.layout.contentItems[0];
  //console.debug('TritonDefaultLayout - info', { themeType, navigation, footer });

  if (typeof document !== `undefined`) {
    document.body.classList.add('triton-default');
  }

  const { 
    //contentItemId,
    //contentType,
    //displayText,
    textColor,
    backgroundColor,
    navItems
  } = navigation.contentItems[0];
  const navigationItems = navItems.contentItems;

  const [sidebarState, setSidebarState] = useState({
    visible: false,
  });

  const handleSidebarHide = () => {
    setSidebarState({ visible: false });
    enableBodyScroll(refMobileSidebarMenuTarget.current);
  }
  const handleSidebarButtonClick = () => {
    setSidebarState({ visible: !sidebarState.visible });
  }
  // Mobile Sidebar Menu - Scroll Locking Behavior
  if (refMobileSidebarMenuTarget.current && sidebarState.visible === true) {
    //console.debug('disableBodyScroll');
    disableBodyScroll(refMobileSidebarMenuTarget.current);
  } else if (refMobileSidebarMenuTarget.current) {
    //console.debug('enableBodyScroll');
    enableBodyScroll(refMobileSidebarMenuTarget.current);
  }

  const { ref: refNavBarTop, inView, 
    //entry 
  } = useInView({
    threshold: 0,
    initialInView: true, //Set the initial value of the inView boolean. This can be used if you expect the element to be in the viewport to start with, and you want to trigger something when it leaves.
    onChange: (inView, entry) => {
      //console.debug('TritonDefaultLayout - useInView - onChange - inView', {inView,entry});
      //console.debug('useInView - onChange - particlesState.particlesContainer', particlesState.particlesContainer);
    }
  });

  const [mobileNavSocialIconsState, setMobileNavSocialIconsState] = useState(null);
  useEffect(() => {
    if (mobileNavSocialIconsState === null) {
      if (navItems && navItems.contentItems && navItems.contentItems.length !== 0) {
        for (const navItem of navItems.contentItems) {
          //console.debug('navItem', navItem)
          if (navItem && navItem.navItems && navItem.navItems.contentItems.length !== 0) {
            for (const navItemItem of navItem.navItems.contentItems) {
              //console.debug('navItemItem', navItemItem)
              if (navItemItem && navItemItem.contentType === 'NavItemSocial') {
                setMobileNavSocialIconsState(navItemItem)
              }
            }
          }
        }
      }
    }
  }, [navItems, mobileNavSocialIconsState]);
  //console.debug('TritonDefaultLayout - mobileNavSocialIconsState', mobileNavSocialIconsState);

  // if (!data?.siteData?.layout?.contentItems?.[0]) {
  //   console.warn('Layout data is missing');
  //   return (
  //     <div className={styles.layout_default}>
  //       <main className={'content-container'}>
  //         {props.children}
  //       </main>
  //     </div>
  //   );
  // }

  return (
    <>
      {GATSBY_GOOGLE_ANALYTICS ?
        <>
          <Script
            src={`https://www.googletagmanager.com/gtag/js?id=`+GATSBY_GOOGLE_ANALYTICS}
          //strategy="off-main-thread"
          />
          <Script id="gtag-config" 
            //strategy="off-main-thread" 
            //forward={[`gtag`]}
          >
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '`+GATSBY_GOOGLE_ANALYTICS+`', { page_path: location ? location.pathname + location.search + location.hash : undefined });
            `}
          </Script>
        </>
      :
        null
      }
      {GATSBY_GOOGLE_TAG ?
        <>
          <noscript><iframe title={'gTag'} src={'https://www.googletagmanager.com/ns.html?id='+GATSBY_GOOGLE_TAG} height="0" width="0" style={{display:'none', visibility:'hidden',}}></iframe></noscript>
        </>
      :
        null
      }

      <div className={styles.layout_default +' triton-default '+ (props.subpage ? props.subpage : '')}>
        <Sidebar.Pushable id={'layout-wrapper'}>
          {isMobile ?
            <Sidebar ref={refMobileSidebarMenuTarget} id={'mobile-sidebar'} animation='overlay' visible={sidebarState.visible} onHide={()=>handleSidebarHide()} style={{background: backgroundColor}}>
              <Menu id={'main-mobile-nav'} inverted vertical borderless fluid style={{background: navigation.background_color}}>
                {navigationItems && navigationItems.map((blok, i) => {
                  //console.debug('blok', blok)
                  return React.createElement(components[blok.contentType], {
                    key: i, 
                    pageArea:'mobile-sidebar-nav', 
                    handleSidebarHide:handleSidebarHide, 
                    header_text_color: textColor, 
                    header_background_color: backgroundColor,
                    ...blok
                  })
                })}
                {mobileNavSocialIconsState ?
                  <NavItemSocialIcons pageArea={'mobile-sidebar-nav'} index={'element'} navItem={mobileNavSocialIconsState} />
                :
                  null
                }
              </Menu>
            </Sidebar>
          :
            null
          }
          <Sidebar.Pusher dimmed={sidebarState.visible}>
            <Segment basic vertical id={'main-nav-container'} textAlign='center' style={{ background: navigation.background_color }}>
              <Menu pointing secondary borderless size='large'
                className={'main-navbar'+ (!isMobile ? ' desktop' : ' mobile') + (inView ? ' not-scrolled' : ' scrolled')}   
                //fixed={'top'}
                fixed={!inView ? 'top' : null}
                style={{ borderTop: 'none', background: backgroundColor }}
              >
                <Container>
                  {navigationItems && navigationItems.map((blok, i) => React.createElement(components[blok.contentType], {
                    key: i, 
                    pageArea: !isMobile ? 'main-nav-container' : 'mobile-main-nav', 
                    header_text_color: textColor, 
                    header_background_color: backgroundColor, 
                    ...blok
                  }))}
                  {isMobile ?
                    <Menu.Item as={Button} className='mobile-navbar-menu-button' onClick={()=>handleSidebarButtonClick()}>
                      <Icon name='sidebar' style={{ color: textColor }} />
                    </Menu.Item>
                  :
                    null
                  }
                </Container>
              </Menu>
            </Segment>
            <div ref={refNavBarTop}></div>
            <main className={'content-container'}>
              {props.children}
            </main>
            <Footer footer={footer} isMobile={isMobile} />
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>

      {/* onetrust */}
      <Script type="text/javascript"
              src={`https://cdn.cookielaw.org/consent/${process.env.GATSBY_ONETRUST}/OtAutoBlock.js`} />
      <Script src={`https://cdn.cookielaw.org/consent/${process.env.GATSBY_ONETRUST}/otSDKStub.js`}
              type="text/javascript"
              charSet="UTF-8"
              data-domain-script={process.env.GATSBY_ONETRUST} />
      <Script type="text/javascript">
        {`
          function OptanonWrapper() { }
        `}
      </Script>
      {/* end onetrust */}
    </>
  )
}
export default TritonDefaultLayout
